export var getSearchParams = function (params) {
    var cleanParams = {};
    for (var _i = 0, _a = Object.entries(params); _i < _a.length; _i++) {
        var entry = _a[_i];
        if (entry[1] !== undefined && entry[1] !== null) {
            cleanParams[entry[0]] = entry[1].toString();
        }
    }
    var urlParams = new URLSearchParams(cleanParams);
    return urlParams.toString();
};
